/**
 * holdMusic.ts — synthesised "on hold" music via the Web Audio API.
 * No audio files needed. Played by the MusicAgent while the account is checked.
 */
let ctx: AudioContext | null = null;
let master: GainNode | null = null;
let timer: number | null = null;
let playing = false;

export function startHoldMusic(): void {
  if (playing) return;
  try {
    const AC = (window as any).AudioContext || (window as any).webkitAudioContext;
    if (!AC) return;
    const audio: AudioContext = new AC();
    const mix = audio.createGain();
    ctx = audio;
    master = mix;
    mix.gain.value = 0.05;
    mix.connect(audio.destination);
    playing = true;

    // Gentle major-pentatonic arpeggio loop.
    const notes = [392.0, 523.25, 587.33, 659.25, 523.25, 440.0]; // G C D E C A
    let i = 0;
    const step = () => {
      if (!playing) return;
      const now = audio.currentTime;
      const osc = audio.createOscillator();
      const g = audio.createGain();
      osc.type = 'triangle';
      osc.frequency.value = notes[i % notes.length];
      g.gain.setValueAtTime(0.0001, now);
      g.gain.linearRampToValueAtTime(0.6, now + 0.04);
      g.gain.exponentialRampToValueAtTime(0.0001, now + 0.6);
      osc.connect(g);
      g.connect(mix);
      osc.start(now);
      osc.stop(now + 0.65);
      i++;
      timer = window.setTimeout(step, 320);
    };
    step();
  } catch {
    /* ignore */
  }
}

export function stopHoldMusic(): void {
  playing = false;
  if (timer) { clearTimeout(timer); timer = null; }
  try { ctx?.close(); } catch { /* ignore */ }
  ctx = null;
  master = null;
}
